export default __webpack_public_path__ + "static/media/i_ioannis.f5f84d90.svg";